const mapEvents = (data: any[]) => {
  return data.map((booking) => ({
    id: booking.id.toString(),
    title: `${booking.products.map(p => p.product_name).join(", ")}`,
    start: booking.booking_date,
    end: booking.booking_date,
    extendedProps: {
      id: booking.id,
      customerName: booking.customer.name,
      bookingStatus: booking.booking_status.status_name,
      bookingStatusSlug: booking.booking_status.status_slug,
      venue: booking.delivery.venue,
      address: `${booking.delivery.address_line_1}, ${booking.delivery.town}`,
      products: booking.products.map(p => ({
        name: p.product_name,
        quantity: p.quantity,
        price: p.item_price
      })),
      paymentStatus: booking.payments[0]?.payment_status || "No Payment",
      totalAmount: booking.payments[0]?.total_amount || 0
    },
  }));
};

export default mapEvents;